var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.023,
    height: 43.022,
    viewBox: "0 0 43.023 43.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.ffad100b1e2572b5b2471b76bd608f55{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.023V43.022H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ffad100b1e2572b5b2471b76bd608f55",
    d: "M6.585,30.1h7.171V17.548H3v8.963A3.6,3.6,0,0,0,6.585,30.1Zm8.963,0H33.475a3.6,3.6,0,0,0,3.585-3.585V17.548H15.548ZM3,8.585v7.17H37.06V8.585A3.6,3.6,0,0,0,33.475,5H6.585A3.6,3.6,0,0,0,3,8.585Z",
    transform: "translate(2.378 3.963)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.dfa0f6f0685a1b4273342bf3baadf81f.svg";
export { ForwardRef as ReactComponent };